"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showNoResultsModal = void 0;
var state_1 = require("../state");
var micromodal_1 = __importDefault(require("micromodal"));
var showNoResultsModal = function () {
    var modal = document.getElementById('famodal_noresults');
    // Don't show if already visible
    if (modal && modal.classList.contains('is-open')) {
        return;
    }
    // Close any existing instance first
    try {
        micromodal_1.default.close('famodal_noresults');
    }
    catch (e) {
        // Modal might not exist
    }
    // Show the no results modal with a small delay to prevent immediate close from event bubbling
    setTimeout(function () {
        try {
            micromodal_1.default.show('famodal_noresults', {
                awaitCloseAnimation: false,
                disableScroll: true,
                openClass: 'is-open'
            });
        }
        catch (e) {
            // Modal element might not exist
        }
    }, 100);
};
exports.showNoResultsModal = showNoResultsModal;
exports.default = (function () {
    var showModal = function () { return micromodal_1.default.show('famodal_matched', {
        awaitCloseAnimation: true,
        disableScroll: true
    }); };
    var getMatched = document.querySelector('[data-modal-get-matched]');
    var form = document.getElementById('famodal_form');
    if (getMatched) {
        getMatched.addEventListener('click', function () {
            micromodal_1.default.close('famodal_matched');
            micromodal_1.default.show('famodal_form', {
                awaitCloseAnimation: true,
                disableScroll: true
            });
        });
    }
    if (form) {
        form.addEventListener('wpcf7mailsent', function () {
            micromodal_1.default.close('famodal_form');
            micromodal_1.default.show('famodal_thankyou', {
                awaitCloseAnimation: true,
                disableScroll: true
            });
        });
    }
    // Show modal when results are displayed. Subscribe (not subscribeOnce) so it works on every run.
    // We want the modal to show when wizardStatus changes to 'hide' (results visible)
    state_1.subscribe('wizardStatus', function (oldState, update) {
        if (update.wizardStatus === 'hide') {
            showModal();
        }
        else if (update.wizardStatus === 'show') {
            // Close no-results modal when user opens wizard to modify answers
            try {
                micromodal_1.default.close('famodal_noresults');
            }
            catch (e) {
                // Modal might not be open
            }
        }
    });
});
